import {
    Component,
    ComponentFactoryResolver,
    ComponentRef,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';

import { BuildingBlockInterface } from './building-block.interface';
import { BuildingBlockInputInterface } from './building-block.model';
import { CallToActionComponent } from './call-to-action/call-to-action.component';
import { HeadingComponent } from './heading/heading.component';
import { ImageListComponent } from './image-list/image-list.component';
import { ImageParagraphComponent } from './image-paragraph/image-paragraph.component';
import { ImageSpotlightComponent } from './image-spotlight/image-spotlight.component';
import { ImageComponent } from './image/image.component';
import { LiveProjectComponent } from './live-project/live-project.component';
import { ParagraphComponent } from './paragraph/paragraph.component';
import { QuoteComponent } from './quote/quote.component';
import { SpacerComponent } from './spacer/spacer.component';
import { SubheadingComponent } from './subheading/subheading.component';
import { TitleComponent } from './title/title.component';
import { VideoComponent } from './video/video.component';

@Component({
    selector: 'app-building-block',
    styleUrls: ['building-block.component.min.css'],
    template: `<ng-container #dynamic></ng-container>`,
})
export class BuildingBlockComponent implements OnDestroy, OnInit {
    @ViewChild('dynamic', { read: ViewContainerRef })
    public container: ViewContainerRef;

    @Input() public context: BuildingBlockInputInterface;
    @Input() @HostBinding('class.padding-required') requiresPadding = false;
    @Input() public type: string;

    private mappings: {[key: string]: any} = {
        'call-to-action': CallToActionComponent,
        'heading': HeadingComponent,
        'image': ImageComponent,
        'live-project': LiveProjectComponent,
        'image-list': ImageListComponent,
        'image-paragraph': ImageParagraphComponent,
        'image-spotlight': ImageSpotlightComponent,
        'paragraph': ParagraphComponent,
        'quote': QuoteComponent,
        'spacer': SpacerComponent,
        'subheading': SubheadingComponent,
        'title': TitleComponent,
        'video': VideoComponent,
    };

    private componentRef: ComponentRef<{}>;

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnInit() {
        if (this.type) {
            const componentType = this.getComponentType(this.type);
            if (componentType === null) {
                return;
            }
            const factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
            this.componentRef = this.container.createComponent(factory);
            const instance = <BuildingBlockInterface>this.componentRef.instance;
            instance.context = this.context;
            this.requiresPadding = this.requiresPadding && instance.paddingEnabled;
        }
    }

    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }

    private getComponentType(type: string) {
        return this.mappings[type] || null;
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/building-block.component.ts